<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-2" d="m25.42,36.32l5.29,20.15c.15.57-.19,1.15-.76,1.29h0s3.5,13.34,3.5,13.34c.16.61-.21,1.24-.81,1.4l-4.95,1.3c-.61.16-1.24-.2-1.4-.81l-3.37-12.81c-.08-.3-.37-.47-.67-.41-4.83.92-9.66-2.07-10.92-6.89l-1.04-3.96c-1.32-5.03,1.71-10.23,6.75-11.55l7.01-1.84c.6-.16,1.21.2,1.37.8Z"/>
  <path class="cls-2" d="m33.86,52.32l-4-15.23c-.16-.6.07-1.23.58-1.58l27.26-19.07c.84-.59,2.01-.16,2.27.83l9.71,36.97c.26.98-.53,1.92-1.54,1.84l-32.97-2.67c-.62-.05-1.15-.49-1.31-1.09Z"/>
  <path class="cls-1" d="m78.29,46.83c-.06,0-.12,0-.18-.02-.38-.1-.6-.49-.5-.86,4.26-16.2-6.49-25.21-6.6-25.3-.3-.25-.35-.69-.1-1,.25-.3.69-.35,1-.1.12.09,11.56,9.69,7.07,26.76-.08.32-.37.53-.68.53Z"/>
  <path class="cls-1" d="m71.51,43.27c-.07,0-.14,0-.2-.03-.37-.11-.59-.51-.48-.88,2.82-9.44-3.92-15.23-3.99-15.28-.3-.25-.34-.7-.09-1,.25-.3.7-.34,1-.09.08.06,7.52,6.45,4.43,16.78-.09.31-.37.51-.68.51Z"/>
</svg>
</template>

<script>
export default {
    name: "PromoByTimeIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #115c72;
  }
  .cls-2 {
    fill: #59c5c7;
  }
</style>